// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueSession from 'vue-session'
import Auth from './layouts/Auth.vue'
import AuthMenu from './layouts/AuthMenu.vue'
import Unauth from './layouts/Unauth.vue'
import shareLinkAuth from './layouts/shareLinkAuth.vue'
import VModal from 'vue-js-modal'
// import component and stylesheet
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'
// import firebase from 'firebase/app'
// import 'firebase/auth'
import { store } from './store'
import VueSweetalert2 from 'vue-sweetalert2'
import ToggleButton from 'vue-js-toggle-button'
import TrendChart from 'vue-trend-chart'
import vBlur from 'v-blur'
const AirbnbDatePicker = () => import('@/components/AirbnbDatePicker.vue')
import LightTimeline from 'vue-light-timeline';
import VueAWN from "vue-awesome-notifications";
import VueProgressBar from 'vue-progressbar'
import VueTranslate from 'vue-translate-plugin';
import '../static/css/main.css'
import customAxios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core'
// import { far } from '@fortawesome/free-regular-svg-icons'
import { faAngry, faRedo, faArrowCircleUp, faArrowLeft, faArrowDown, faArrowRight, faArrowUp, faAt, faBan, faBell, faBook, faBug, faBuilding, faBullseye, faCalendarAlt, faCaretDown, faCaretUp, faChartBar, faChartLine, faCheck, faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faCircleNotch, faClock, faCog, faComment, faCommentAlt, faCopy, faCrown, faDesktop, faDollarSign, faDoorOpen, faDownload, faEdit, faEllipsisV, faEnvelope, faExpand, faExternalLinkAlt, faEye, faFile, faFileAlt, faFilter, faFingerprint, faFire, faFlag, faFlask, faGem, faGift, faGreaterThan, faHandPointer, faHeart, faHome, faHourglass, faInbox, faIndustry, faInfoCircle, faLayerGroup, faLessThan, faLightbulb, faLink, faList, faLock, faLongArrowAltDown, faLongArrowAltLeft, faLongArrowAltRight, faMagic, faMapMarkerAlt, faMinusSquare, faMobileAlt, faMoneyBill, faMouse, faMousePointer, faPaperPlane, faPaperclip, faPaste, faPen, faPencilAlt, faPencilRuler, faPercentage, faPlay, faPlus, faPlusSquare, faPollH, faQuestionCircle, faReceipt, faRedoAlt, faReply, faRobot, faRocket, faSave, faSearch, faShapes, faShare, faShareSquare, faSignOutAlt, faSignature, faSortAmountDown, faStar, faTabletAlt, faTachometerAlt, faThumbsDown, faTimes, faTrash, faUndoAlt, faUserCheck, faUserCircle, faUserPlus, faUserTag, faUsers, faVideo, faWalking, faThumbtack, faPaintBrush, faCode, faStop, faPlug, faUndo } from '@fortawesome/free-solid-svg-icons'
import { fab, faMarkdown } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueCalendarHeatmap from 'vue-calendar-heatmap'

library.add(fab, faRedo, faPlug, faRocket, faCode, faPaintBrush, faArrowDown, faIndustry, faHeart, faThumbsDown, faArrowCircleUp, faDoorOpen, faCaretUp, faPencilAlt, faSave, faEye, faUndoAlt, faRedoAlt, faUsers, faCircleNotch, faTrash, faLongArrowAltLeft, faLock, faLink, faList, faInfoCircle, faPen, faCrown, faChevronDown, faChevronUp, faLightbulb, faCaretDown, faEdit, faLongArrowAltDown, faClock, faVideo, faMagic, faDownload, faMousePointer, faQuestionCircle, faPaste, faCheck, faLongArrowAltRight, faSearch, faPaperclip, faAngry, faBug, faStar, faLayerGroup, faMapMarkerAlt, faSignature, faAt, faUserTag, faPercentage, faGreaterThan, faLessThan, faTimes, faChevronLeft, faFlag, faExternalLinkAlt, faPaperPlane, faBook, faInbox, faBell, faBan, faShapes, faBuilding, faReceipt, faDollarSign, faBullseye, faSortAmountDown, faDesktop, faMobileAlt, faTabletAlt, faFilter, faMouse, faWalking, faShare, faChartBar, faEllipsisV, faReply, faCog, faPlusSquare, faFingerprint, faChevronRight, faFile, faShareSquare, faMinusSquare, faMoneyBill, faGift, faSignOutAlt, faRobot, faFire, faChartLine, faFlask, faHourglass, faComment, faHome, faFileAlt, faPollH, faCommentAlt, faPencilRuler, faUserCheck, faUserPlus, faGem, faArrowLeft, faArrowRight, faArrowUp, faPlay, faExpand, faEnvelope, faHandPointer, faPlus, faTachometerAlt, faCopy, faUserCircle, faCalendarAlt, faThumbtack, faStop, faMarkdown, faUndo)
import VueIntro from 'vue-introjs';
Vue.component('font-awesome-icon', FontAwesomeIcon)

const http = customAxios.create();
Vue.prototype.$http = http;
Vue.prototype.axiosCancelSource = null;
Vue.prototype.ongoingRequests = new Set();
Vue.prototype.$version = 1;

http.interceptors.request.use((config) => {
  // Generate a unique key for the request (e.g., METHOD_URL)
  const requestKey = `${config.method}_${config.url}`;

  // If a duplicate request is found, cancel it
  if (Vue.prototype.ongoingRequests.has(requestKey)) {
    // if (Vue.prototype.axiosCancelSource && !config.allowDuplication) {
    //   Vue.prototype.axiosCancelSource.cancel(`Duplicate request: ${requestKey}`);
    // }

  } else {
    // Store the request key in the ongoingRequests Set
    Vue.prototype.ongoingRequests.add(requestKey);
  }

  // Attach the cancel token to the request config
  // if (Vue.prototype.axiosCancelSource) {
  //   config.cancelToken = Vue.prototype.axiosCancelSource.token;
  // }
  return config;
}, (error) => {
  // Handle request errors
  if (error.config) {
    const requestKey = `${error.config.method}_${error.config.url}`;
    Vue.prototype.ongoingRequests.delete(requestKey);
  }
  return Promise.reject(error);
});

http.interceptors.response.use((response) => {
  // Generate a unique key for the request (e.g., METHOD_URL)
  const requestKey = `${response.config.method}_${response.config.url}`;
  // Remove the request key from the ongoingRequests Set
  Vue.prototype.ongoingRequests.delete(requestKey);

  return response;
},
(error) => {
  console.log(error)
  // Handle response errors and remove request from ongoingRequests Set
  if (error.config) {
    const requestKey = `${error.config.method}_${error.config.url}`;
    Vue.prototype.ongoingRequests.delete(requestKey);
  }

  // Always return a rejected promise to maintain the error state
  return Promise.reject(error);
}
);

// Import the plugin here
import { Auth0Plugin } from "./auth";
// const Auth0Plugin = () => import('./auth')

require("vue-awesome-notifications/dist/styles/style.css")
Vue.use(VueCalendarHeatmap)
Vue.use(VueAWN, options);
Vue.use(VueIntro);
Vue.use(VueTranslate);
Vue.use(LightTimeline);
Vue.use(VueProgressBar, {
  color: '#156ef6',
  failedColor: 'red',
  height: '20px',
  zIndex: '9999999999999999'
})
// route, shapes, shoe-prints

// see docs for available options
const datepickerOptions = {
  colors: {
    selected: '#004da9',
    inRange: '#849ed6',
    hoveredInRange: '#849ed6',
    selectedText: '#fff',
    text: '#565a5c',
    inRangeBorder: '#2f4fdf',
    disabled: '#fff'
  }
}

// make sure we can use it in our components
Vue.use(AirbnbStyleDatepicker, datepickerOptions)
Vue.use(VModal)
Vue.use(VueSweetalert2)
Vue.use(ToggleButton)
Vue.use(TrendChart)
Vue.use(vBlur)
Vue.component('AirbnbDatePicker', AirbnbDatePicker);
Vue.component('no-sidebar-layout', Unauth)
Vue.component('auth-layout', Auth)
Vue.component('auth-menu-layout', AuthMenu)
Vue.component('share-link-layout', shareLinkAuth)

Vue.component('content-placeholders', {
  template: `<div class="placeholder placeholder-sentence"></div><div class="placeholder placeholder-sentence"></div><div class="placeholder placeholder-sentence"></div>`
})

var options = {
  persist: true
}
Vue.use(VueSession, options)
Vue.config.productionTip = false
Vue.config.silent = true

http.interceptors.request.use(function (config) {
  if (window.location.href.includes('https://ixo.6ix.com')) config.url = config.url.replace('https://api.howuku.com', 'https://api-ixo.6ix.com')
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});


if (!http.defaults.headers.jwt) http.defaults.headers.jwt = localStorage.getItem('jwt')
if (localStorage.getItem('Tz')) http.defaults.headers.tz = localStorage.getItem('Tz')
if (!http.defaults.headers.tz){
  http.defaults.headers.tz = new Date().getTimezoneOffset() / 60
  localStorage.setItem('Tz', http.defaults.headers.tz)
}

try {
  if (localStorage.getItem('widget_id')) http.defaults.headers.widgetid = localStorage.getItem('widget_id')
} catch (err) {
  console.error(err)
}

// http.defaults.withCredentials = true

Vue.prototype.$checkInstallationStatus = function() {
  http.get(process.env.API_ENDPOINT + '/installation/show-banner/' + this.$session.get('widget_id'))
    .then((response) => {
      if (response.status === 204) {
        store.commit('setInstallationBanner', true)
        localStorage.setItem('banner:installation', true);
      } else {

        // from show to no show... mean have installed successfully
        if (localStorage.getItem('banner:installation') === 'true') {
          try {
            this.$auditlog({ module: 'installation', action: 'tracking_code_installed' })  
            mida.track('tracking_code_installed')
          } catch(e) {}
        }

        store.commit('setInstallationBanner', false)
        localStorage.setItem('banner:installation', false);        
      }
    })
    .catch(err => {
      store.commit('setInstallationBanner', false)
      localStorage.setItem('banner:installation', false);        
      console.error(err)
    }) 
}

Vue.prototype.$auditlog = function(json) {
  http.post(process.env.API_ENDPOINT + '/auditlog', {
    module: json.module ? json.module : '',
    action: json.action ? json.action : '',
    action_id: json.action_id ? json.action_id : 0,
    description: json.description ? json.description : '',
  }).then(() => {
    console.log('success')
  })
}

Vue.prototype.$findAuditlog = async function(json) {
  if(!this.$route.params.encryptedParam){
    return (await http.post(process.env.API_ENDPOINT + '/auditlog/find', json)).data
  }
}

Vue.prototype.$isExceedingLimit = function (usage, colName) {
  return new Promise((resolve, reject) => {
    http.get(process.env.API_ENDPOINT + '/planInfo')
    .then((response) => {
      let plan = response.data[0]
      let planLimit = plan[colName]

      if (usage >= planLimit) {
        resolve(true)
      } else {
        resolve(false)
      }
    })
    .catch(err => {
      reject(err)
    })
  })
}

Vue.prototype.$getLimit = function (colName) {
  return new Promise((resolve, reject) => {
    http.get(process.env.API_ENDPOINT + '/planInfo')
    .then((response) => {
      let plan = response.data[0]
      let planLimit = plan[colName]
      resolve(planLimit)
    })
    .catch(err => {
      reject(err)
    })
  })
}

Vue.prototype.$isWhitelabel = () => {
  return !window.location.host.includes('localhost') && !window.location.host.includes('mida-dev') && !window.location.host.includes('howuku-dev') && !window.location.host.includes('howuku.com')
}

Vue.prototype.$userTimeNow = (dt = null) => {
  let hourDiff = 0;
  if (localStorage.getItem('Tz')) hourDiff = localStorage.getItem('Tz')
  else hourDiff = new Date().getTimezoneOffset() / 60

  let momentObj = dt ? moment(dt) : moment()
  let utc2UserTimezone = momentObj.utc().add(hourDiff * -1, 'hour');
  return utc2UserTimezone
}

Vue.prototype.$initTranslation = () => {
  return new Promise((resolve, reject) => {
    let localTrans = localStorage.getItem('translation')
    let interval = null
    if (localTrans) {
      Vue.locales(JSON.parse(localTrans))
    }

    http.get(process.env.API_ENDPOINT + '/translation')
    .then((result) => {
      Vue.locales(result.data)
      localStorage.setItem('translation', JSON.stringify(result.data));
      resolve();
    })
    .catch(err => {
      reject(err);
    })

    interval = setInterval(() => {
      // clearInterval(interval)
      if (window.untranslated) {
        // console.log('post translation', window.untranslated)
        let list = window.untranslated
        let tlist = list.filter(function (item, pos, self) {
          return self.indexOf(item) == pos
        })
        this.$http
          .post(process.env.API_ENDPOINT + '/translation', {
            translation: JSON.stringify(tlist),
          })
          .then((response) => {
            window.untranslated = null
          })
          .catch((err) => {
            console.error(err)
          })
      }
    }, 5000)
  })
}

Vue.prototype.$isFreePlan = [0, 4]
Vue.prototype.$isBasicPlan = [1, 101, 201]
Vue.prototype.$isProPlan = [2, 102, 202]
Vue.prototype.$isLegacyFreePlan = [0, 4]
Vue.prototype.$isGrowthPlan = [5]
Vue.prototype.$isPremiumPlan = [3,7,8,9,10,11,12,103, 203, 106]
Vue.prototype.$isNewWhiteLabelPlan = [104]

Vue.prototype.$initDomain = () => {
  return new Promise((resolve, reject) => {
    let url = window.location.host
    let subdomain = url.replace('.howuku.com','')

    function setFavicon (url) {
      var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = url;
      document.getElementsByTagName('head')[0].appendChild(link);

      document.querySelector("link[rel*='icon']").href = url;
      console.log('set favicon ' + url)
    }

    if (window.location.host.includes('app.howuku.com') || window.location.host.includes('optimize.howuku.com')) setFavicon('https://uploads-ssl.webflow.com/62679692b1466017b8eae590/6281d123e49d2cbac0a71b9a_fav32.png');

    if(window.location.host.includes('app.mida.so')  || window.location.href.includes('localhost:') || window.location.href.includes('mida-dev:') || window.location.href.includes('howuku-dev:')) {
      document.title = 'Mida | A/B Testing Platform'
      Vue.prototype.$logo = 'https://uploads-ssl.webflow.com/64fddd2973684cc4d9ae26ac/65071808ef4da26a10dc6972_mida-logo.png'
      Vue.prototype.$name = 'Mida'
      Vue.prototype.$favicon = 'https://uploads-ssl.webflow.com/64fddd2973684cc4d9ae26ac/65028fa5832642947e53e568_favicon-32x32.png'
      // Vue.prototype.$MainColor = '20, 110, 246'
      Vue.prototype.$MainColor = '18, 50, 75'
      
      document.body.style.setProperty('--main-color', Vue.prototype.$MainColor)
      localStorage.setItem('--main-color', Vue.prototype.$MainColor)
      setFavicon(Vue.prototype.$favicon)
    } else if(subdomain === 'app') {
      document.title = 'Howuku | All-in-one CRO & Web Analytics Platform'
      Vue.prototype.$logo = 'https://cdn.howuku.com/images/logo.svg?v=2',
      Vue.prototype.$name = 'Howuku',
      Vue.prototype.$favicon = 'https://uploads-ssl.webflow.com/62679692b1466017b8eae590/6281d123e49d2cbac0a71b9a_fav32.png',
      Vue.prototype.$MainColor = '5, 74, 218'
      document.body.style.setProperty('--main-color', Vue.prototype.$MainColor)
      localStorage.setItem('--main-color', Vue.prototype.$MainColor)

      http.get(process.env.API_ENDPOINT + '/cdnDomain')
        .then((result) => {
          if (result.data.length) Vue.prototype.$customCDN = result.data[0].cdn_domain
          resolve()
        })
    } else if(subdomain === 'optimize') {
      document.title = 'Optimize By Howuku | A/B Testing & Optimization'
      Vue.prototype.$logo = 'https://uploads-ssl.webflow.com/62679692b1466017b8eae590/64d90bfd399cb463eb1cd562_optimize.png',
      Vue.prototype.$name = 'Optimize By Howuku',
      Vue.prototype.$favicon = 'https://uploads-ssl.webflow.com/62679692b1466017b8eae590/6281d123e49d2cbac0a71b9a_fav32.png',
      Vue.prototype.$MainColor = '29,41,57'
      document.body.style.setProperty('--main-color', Vue.prototype.$MainColor)
      localStorage.setItem('--main-color', Vue.prototype.$MainColor)

      http.get(process.env.API_ENDPOINT + '/cdnDomain')
        .then((result) => {
          if (result.data.length) Vue.prototype.$customCDN = result.data[0].cdn_domain
          resolve()
        })
    } else {
      document.title = window.location.hostname

      if (localStorage.getItem('website_logo')){
        let localLogo = localStorage.getItem('website_logo')
        Vue.prototype.$logo = localLogo && localLogo !== 'null' && localLogo !== '' ? localLogo : 'https://cdn.howuku.com/images/logo.svg?v=2'
        Vue.prototype.$name = localStorage.getItem('website_name') ? localStorage.getItem('website_name') : 'Howuku'
        Vue.prototype.$favicon = localStorage.getItem('website_favicon') ? localStorage.getItem('website_favicon') : ''
        Vue.prototype.$MainColor = localStorage.getItem('--main-color') ? localStorage.getItem('--main-color') : '5, 74, 218'
        Vue.prototype.$customCDN = localStorage.getItem('website_cdn_domain') ? localStorage.getItem('website_cdn_domain') : ''
        if (localStorage.getItem('website_name')) document.title = localStorage.getItem('website_name')

        if (localStorage.getItem('css_stylesheet')) {
          var element = document.createElement("link");
          element.setAttribute("rel", "stylesheet");
          element.setAttribute("type", "text/css");
          element.setAttribute("href", localStorage.getItem('css_stylesheet'));
          document.getElementsByTagName("head")[0].appendChild(element);
        }

        if (Vue.prototype.$favicon) setFavicon(Vue.prototype.$favicon);
      }

      if (localStorage.getItem('website_favicon'))  document.querySelector("link[rel*='icon']").href = localStorage.getItem('website_favicon');


      http.get(process.env.API_ENDPOINT + '/domain/setting/' + subdomain)
      .then((result) => {
        if (result.data.length) {
          let logo = ''
          if (result.data[0].website_logo) logo = result.data[0].website_logo
          Vue.prototype.$logo = logo,
          Vue.prototype.$name = result.data[0].website_name ? result.data[0].website_name : document.title
          Vue.prototype.$favicon = result.data[0].website_favicon ? result.data[0].website_favicon : localStorage.getItem('website_favicon')
          Vue.prototype.$customCDN = result.data[0].cdn_domain ? result.data[0].cdn_domain : localStorage.getItem('website_cdn_domain')

          Vue.prototype.$MainColor = result.data[0].main_color

          if(result.data[0].sso_flag === 1){
            let domain = result.data[0].sso_domain
            let clientId = result.data[0].sso_client_id
            let clientSecret = result.data[0].sso_client_secret
            window._howuku_sso = true
            Vue.use(Auth0Plugin, {
              domain,
              clientId,
              clientSecret,
              onRedirectCallback: appState => {
                router.push({ path: '/login' });
             }
            })
          }
          localStorage.setItem('website_favicon', Vue.prototype.$favicon)
          localStorage.setItem('website_logo', logo)
          localStorage.setItem('website_name', Vue.prototype.$name)
          localStorage.setItem('--main-color', result.data[0].main_color)
          localStorage.setItem('website_cdn_domain', Vue.prototype.$customCDN)
          document.body.style.setProperty('--main-color', Vue.prototype.$MainColor)
          if (localStorage.getItem('website_name')) document.title = localStorage.getItem('website_name')
          if (result.data[0].CSS_url){
            localStorage.setItem('css_stylesheet', result.data[0].CSS_url)

            var element = document.createElement("link");
            element.setAttribute("rel", "stylesheet");
            element.setAttribute("type", "text/css");
            element.setAttribute("href", result.data[0].CSS_url);
            document.getElementsByTagName("head")[0].appendChild(element);
          } else {
            localStorage.removeItem('css_stylesheet')
          }

          if (Vue.prototype.$favicon) setFavicon(Vue.prototype.$favicon);

          resolve()
        } else {

          // test 6ix css
          // var element = document.createElement("link");
          // element.setAttribute("rel", "stylesheet");
          // element.setAttribute("type", "text/css");
          // element.setAttribute("href", 'https://6ix.com/ix-modules/6ix-ix-ixo.css');
          // document.getElementsByTagName("body")[0].appendChild(element);

          // console.log('domain not found on database')

          Vue.prototype.$logo = 'https://cdn.howuku.com/images/logo.svg?v=2',
          Vue.prototype.$name = 'Howuku'
          Vue.prototype.$MainColor = '5, 74, 218'
          Vue.prototype.$customCDN = ''
          document.body.style.setProperty('--main-color', Vue.prototype.$MainColor)
          localStorage.setItem('--main-color', Vue.prototype.$MainColor)

          // if (!window.location.href.includes('localhost')) {
          //   window.location.href = 'https://app.howuku.com/'
          // }
          resolve()
        }
      })
    }
  })
}

Vue.prototype.$notiCount = function() {
  if(!this.$route.params.encryptedParam){
    this.$http
      .post(process.env.API_ENDPOINT + '/comments', {
        widget_id: this.$session.get('widget_id'),
        startDate: this.$userTimeNow().add(-100, 'day').format('YYYY-MM-DD'),
        endDate: this.$userTimeNow().add(1, 'day').format('YYYY-MM-DD'),
      })
      .then((response) => {
        let count = 0
        let data = response.data
        data.map(x => count += Number(x.feedback_status) === 0 ? 1 : 0)
        store.commit('setNotifFeedback', count)
      })
  }
}

// Vue.prototype.$CurrencyMY =
// fetch('https://ipapi.co/json/').then(function(response) {
//   return response.json();
// })
// .then(function(data) {
//   let country_code = data.country_code
//   if(country_code === 'MY' || country_code === 'IN') localStorage.setItem('country_code', country_code)
//   // localStorage.setItem('country_code', 'IN')
// });

Vue.prototype.$isDisposableEmail = function (emailCheck) {
  return new Promise((resolve, reject) => {
    fetch('https://disposable.debounce.io/?email=' + emailCheck).then(function (response) {
      return response.json();
    })
      .then(function (data) {
        let disposable_email = data.disposable
        if (disposable_email == 'true') {
          resolve(true)
        } else {
          resolve(false)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

Vue.prototype.$isFeatureEnabled = function (key) {
  if(window.howuku && window.howuku.isFeatureEnabled) return window.howuku.isFeatureEnabled(key)
  return false
}

Vue.prototype.$isOptimize = window.location.href.includes('optimize.howuku.com') || window.location.href.includes('app.mida.so')               //   || window.location.href.includes('localhost:')
Vue.prototype.$isHowuku = window.location.href.includes('.howuku.com/') || window.location.href.includes('.mida.so/') || window.location.href.includes('localhost:')
Vue.prototype.$isMida = window.location.href.includes('.mida.so')                       //  || window.location.href.includes('localhost:')

if (Vue.prototype.$isOptimize || Vue.prototype.$isMida) Vue.prototype.$version = 2; // to hide project from header

Vue.prototype.$customdomain = function() {
  return {
    logo: Vue.prototype.$logo,
    name: Vue.prototype.$name
  }
}

Vue.prototype.$getCustomCDN = function() {
  if (Vue.prototype.$customCDN) return Vue.prototype.$customCDN
  return Vue.prototype.$isMida ? 'cdn.mida.so' : 'cdn.howuku.com'
}

Vue.prototype.$trackingURL = function() {
  if (Vue.prototype.$customCDN) return Vue.prototype.$customCDN
  return Vue.prototype.$isMida ? 'cdn.mida.so' : 'cdn.howuku.com'
}

Vue.prototype.$download = function (name, data) {
  var csvContent = ''
  data.forEach(function(infoArray, index) {
    dataString = infoArray.join(';')
    csvContent += index < data.length ? dataString + '\n' : dataString
  })

  var download = function(content, fileName, mimeType) {
    var a = document.createElement('a')
    mimeType = mimeType || 'application/octet-stream'

    if (navigator.msSaveBlob) { // IE10
      navigator.msSaveBlob(new Blob([content], {
        type: mimeType
      }), fileName)
    } else if (URL && 'download' in a) { //html5 A[download]
      a.href = URL.createObjectURL(new Blob([content], {
        type: mimeType
      }))
      a.setAttribute('download', fileName)
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    } else {
      location.href = 'data:application/octet-stream,' + encodeURIComponent(content) // only this mime type is supported
    }
  }
  download(csvContent, name, 'text/csv;encoding:utf-8')
}

Vue.filter('statusText', function (value) {
  if (value) {
    return 'Active'
  }
  return 'Inactive'
})

Vue.filter('capitalize', function (s) {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
})

let app = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

// firebase.auth().onAuthStateChanged(user => {
//   if (user) {
//     store.commit('setCurrentUser', user)
//   } else {
//     store.commit('setCurrentUser', null)
//   }
// })

export default app



// WEBPACK FOOTER //
// ./src/main.js